import { IFormValues } from "../form-modal/form-modal.types";
import { FormModal } from "../form-modal/form-modal.component";

import { NewCampaignBriefForm } from "./components/new-campaign-brief-form/new-campaign-brief-form.component";
import { NewCampaignBriefModalProps } from "./new-campaign-brief-modal.props";
import { validation } from "./components/new-campaign-brief-form/new-campaign-brief-form.validation";

export const NewCampaignBriefModal = (props: NewCampaignBriefModalProps) => {
  const handleSubmit = (data: IFormValues) => {
    props.onSubmit({ ...data, resourcetype: data.resourcetype.value });
  };

  return (
    <FormModal
      Form={NewCampaignBriefForm}
      defaultValues={{ name: "", resourcetype: null, is_under_nda: false }}
      formValidation={validation}
      isOpen={props.isOpen}
      modalErrors={props.errors}
      modalTitle="New Campaign Brief"
      onClose={props.onClose}
      submit={handleSubmit}
    />
  );
};
